/** Task ids as `TasksEnum` names them on the backend. */
export const TASKS = {
  OVERVIEW: 1000,
  OVERVIEW_STRATEGIC: 1001,
  OVERVIEW_ANALYTIC: 1002,
  LINKS: 1300,
  LINKS_CREATE: 1301,
  LINKS_UPDATE: 1302,
  LINKS_DELETE: 1303,
  LINKS_REFRESH: 1304,
  LINKS_EVENTS: 1305,
  LINK_ACCOUNTS: 1400,
  LINK_ACCOUNTS_MANAGE: 1401,
  CASH_POSITION: 1500,
  CASH_POSITION_BALANCE_LIMITS: 1507,
  CASH_POSITION_MANAGE: 1509,
  FORECAST: 1600,
  FORECAST_MANAGE: 1601,
  ACCOUNTS_HISTORY_1700: 1700,
  ACCOUNTS_HISTORY_1700_MANAGE: 1701,
  INVESTMENT: 1800,
  INVESTMENT_MANAGE: 1820,
  TRANSACTIONS: 2000,
  PAYMENTS: 2001,
  TRANSFERS: 2002,
  PAYMENTS_RECEIPT: 2003,
  PIX: 2004,
  PAYMENT_SLIPS: 2006,
  TRANSACTIONS_MANAGE: 2008,
  PAYMENTS_MANAGE: 2009,
  PIX_MANAGE: 2010,
  CATEGORIES: 2100,
  CATEGORIZATION_AUDIT: 2103,
  CATEGORIES_MANAGE: 2104,
  CASH_FLOW: 2200,
  CASH_FLOW_MANAGE: 2202,
  INTERCOMPANY: 2300,
  INTERCOMPANY_MANAGE: 2301,
  NOTIFICATIONS: 3000,
  NOTIFICATION_RULES_MANAGE: 3003,
  REPORTS: 4000,
  REPORTS_SCHEDULE: 4003,
  BANK_STATEMENT: 5000,
  PERIOD_STATEMENT_EXECUTION: 5001,
  FINANCIAL_CLOSING: 5002,
  PERIOD_STATEMENT_EXECUTION_MANAGE: 5003,
  CURRENCY: 5100,
  CURRENCY_RATES_EDIT: 5101,
  DEBT: 5200,
  DEBT_MANAGE: 5201,
  TARIFFS: 5300,
  SETTINGS_WORKSPACES: 5502,
  SETTINGS_USERS: 5503,
  SETTINGS_SECURITY: 5504,
  SETTINGS_CREDENTIALS: 5505,
  SUPPORT_TICKETS: 5507,
  DEVELOPERS_IP_WHITELIST: 6101,
  CASH_POOLING: 8000,
  CASH_POOLING_MANAGE: 8001,
  POLICY: 8100,
} as const;

/** Whether the reader holds this task itself; a child task does not count, so it suits action tasks. */
export const canTask = (ability: { can: (action: string, subject: string) => boolean }, taskId?: number | null) => {
  if (taskId == null) return true;
  const id = String(taskId);
  return ability.can('enabled', id) && ability.can('allowed', id);
};

export const canAnyTask = (ability: { can: (action: string, subject: string) => boolean }, ...taskIds: number[]) => (
  taskIds.some((taskId) => canTask(ability, taskId))
);

export const canManageScreen = (
  ability: { can: (action: string, subject: string) => boolean },
  screenTaskId: number,
  ...manageTaskIds: number[]
) => !canTask(ability, screenTaskId) || canAnyTask(ability, ...manageTaskIds);
